let fallback = {}

export const setItem = (key, val) => {
  try {
    return sessionStorage.setItem(key, val)
  } catch (error) {
    fallback[key] = val
    return undefined
  }
}

export const getItem = (key) => {
  try {
    return sessionStorage.getItem(key)
  } catch (error) {
    return fallback[key] || null
  }
}

export const removeItem = (key) => {
  try {
    return sessionStorage.removeItem(key)
  } catch (error) {
    delete fallback[key]
    return undefined
  }
}

export const clear = () => {
  try {
    return sessionStorage.clear()
  } catch (error) {
    fallback = {}
    return undefined
  }
}
